

export const loadingStyle = {
    fill: "white",
    height: "100%",
    width: "100%",
    position: "absolute",
    zIndex: "1000",
    top: "45%",
}